import {
    SHOW_ERRORS, SHOW_LOADER, STOP_LOADER, SHOW_MSG, SET_NOTIFICATION, SET_HEALTH
} from "constants/general.constants";

const INIT_STATE = {
    loader: false,
    alertMessage: '',
    showMessage: false,
    notification: {
        open: false,
        status: '',
        message: '',
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case SHOW_MSG: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true
            }
        }
        case SHOW_ERRORS: {
            return {
                ...state,
                loader: false,
                alertMessage: action.payload,
                showMessage: true
            }
        }
        case SHOW_LOADER: {
            return {
                ...state,
                loader: true,
                showMessage:false
            }
        }

        case STOP_LOADER: {
            return {
                ...state,
                loader:false,
                showMessage:(action.payload == null || action.payload === undefined) ? false : true,
                alertMessage: action.payload
            }
        }

        case SET_NOTIFICATION: {
            return {
                ...state,
                notification: action.notification
            }
        }
        default:
            return state;
    }
}